import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import './style/editor.scss';
import { parseMarkup } from 'openlexia-markup';

import Title from '../../shared/components/Title';
import Button from '../../shared/components/Button';
import Textarea from '../../shared/components/Textarea';
import Input from "../../shared/components/Input";
import UploadZone from "../../shared/components/UploadZone";
import MediaList from "../../shared/components/MediaList";
import { saveDraft } from './infra/repository/SaveDraft';
import { publishDraft} from "./infra/repository/PublishDraft";
import { findDraftById} from "./infra/repository/FindDraftById";
import { uploadMedia } from './infra/repository/UploadMedia';
import { deleteMedia } from './infra/repository/DeleteMedia';



export default () => {

    // get url params
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const [pageName, setPageName] = useState('');
    const [markup, setMarkup] = useState('');
    const [draftId, setDraftId] = useState(params.get("draftId"));
    const [htmlPreview, setHtmlPreview] = useState('');
    const [debounceTimeout, setDebounceTimeout] = useState(null);
    const [medias, setMedias] = useState([]);

    function loadHtmlPreview() {
        const result = parseMarkup(markup);
        if (!result) {
            setHtmlPreview('');
        }
        setHtmlPreview(result);
    }

    const loadDraft = async (draftId) => {
        try {
            const data = await findDraftById(draftId);
            setPageName(data.name);
            setMarkup(data.markup);
            setDraftId(data.id);
            setMedias(data.medias);
        } catch (err) {
            console.log(err.message);
        }
    };

    const reloadMediaList = async () => {
        const data = await findDraftById(draftId);
        setMedias(data.medias);
    };

    const onDropMedia = async (media) => {
        try {
            await uploadMedia(draftId, media.name, media.type, media.file);
            console.log('Upload successful:');
            await reloadMediaList();
        } catch (err) {
            console.log(err.message);
        }
    };

    const onDeleteMedia = async (mediaId) => {
        try {
            await deleteMedia(draftId, mediaId);
            console.log('Media deleted successfully:');
            await reloadMediaList()
        } catch (error) {
            console.error('Error deleting media:', error);
            throw error;
        }
    };

    const save = () => {

        const draft = {
            id: draftId,
            name: pageName,
            markup: markup
        }

        saveDraft(draft)
    };

    const publish = () => {
        publishDraft(draftId, htmlPreview);
    };

    useEffect(() => {
        loadDraft(draftId);
    }, []); // Empty dependency array ensures this runs only once

    useEffect(() => {
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }

        // Debounce the input to avoid parsing the markup on every keystroke
        const timeout = setTimeout(() => {
            loadHtmlPreview();
        }, 1000);

        setDebounceTimeout(timeout);

        return () => clearTimeout(timeout);
    }, [markup]);


    return (
        <>
            <section className='draft-editor__container'>
                <Title title='Draft editor' />
                <div className='markup-editor'>
                    <div className='markup-editor__header'>
                        <div className='button-container'>
                            <Button text='Save draft' onClick={save} />
                            <Button text='Publish' onClick={publish} />
                        </div>
                    </div>

                    <div className='block'>
                        <span>Page name</span>
                        <Input
                            classList='text'
                            placeholder='Lecture name'
                            value={pageName}
                            onChange={(e) => setPageName(e.target.value)}
                        />
                    </div>
                    <div className='block'>
                        <span>Upload media</span>
                        <UploadZone
                            draftId={draftId}
                            onDropMedia={(media) => onDropMedia(media)}
                        />
                        <MediaList
                            medias={medias}
                            onDeleteMedia={(mediaId) => onDeleteMedia(mediaId)}
                        />
                    </div>
                    <div className='markup-preview-editor__container'>
                        <div className='markup-preview-editor__container--editor'>
                            <div>Markup</div>
                            <Textarea
                                type='small'
                                className='markup-text'
                                rows='30'
                                cols='100'
                                placeholder='Write your markup here...'
                                value={markup}
                                onChange={(e) => setMarkup(e.target.value)}
                            />
                        </div>

                        <div className='markup-preview-editor__container--preview'>
                            <div>Preview</div>
                            <div
                                className='markup-preview'
                                dangerouslySetInnerHTML={{ __html: htmlPreview }}
                            ></div>
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
};
